var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CForm',{ref:"searchForm",attrs:{"structure":_vm.structure,"options":{ submit: { text: 'Rechercher', variant: 'info'}, reset: { text: 'Réinitialiser', variant: 'light'} }},on:{"onSubmit":_vm.onSubmit,"onReset":_vm.onReset}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }